import React, {Component} from 'react';
import { connect } from 'react-redux';

import {
    SIDEBAR_HIDE_ALL
} from '../../../constants/sidebars';

class MobileOverlay extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shown: false
        };

        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        let {dispatch} = this.props;
        dispatch({type: SIDEBAR_HIDE_ALL});
    }

    componentWillReceiveProps(nextProps) {
        let {sidebars} = nextProps;

        this.setState({
            shown: sidebars.leftShown || sidebars.rightShown
        });
    }

    render() {
        if (!this.props.browser.mobile) return null;

        return (
            <div className="shadow" style={{display: this.state.shown ? 'block' : 'none'}} onClick={this.onClick}/>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        browser: state.browser,
        sidebars: state.sidebars
    }
}

export default connect(mapStateToProps)(MobileOverlay);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/MobileOverlay/index.js